import React from 'react';

import AuthCardWrapper from '../../../src/theme/mantis/sections/auth/authCardWrapper';
import ResetPasswordForm from '../../components/resetPasswordForm/ResetPasswordForm';

const ResetPass = () => {
    return (
        <AuthCardWrapper>
            <ResetPasswordForm />
        </AuthCardWrapper>
    )
}

export default ResetPass